import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { BACKEND_URL } from '../consts';

const Confirm = () => {
    const [email, setEmail] = useState(() => localStorage.getItem('email') || '');
    const [confirm, setConfirm] = useState(() => localStorage.getItem('confirm') || '');
    const [code, setCode] = useState(['-', '-', '-', '-', '-', '-']);
    const [isCodeValid, setIsCodeValid] = useState(false);
    const [timer, setTimer] = useState(54); // Время для обратного отсчета
    const [isEdit, setIsEdit] = useState(false);
    const [error, setError] = useState('')
    console.log(confirm)

    useEffect(() => {
        localStorage.setItem('email', email);
    }, [email]);

    const submitData = async () => {
        // Сохраняем адрес электронной почты в куки
        Cookies.set('email', email);

        try {
            // Отправляем POST запрос
            const response = await axios.post(`${BACKEND_URL}/api/v1/auth/password-reset/confirm`, {
                email: email
            });

            // Обработка успешного ответа
            console.log('Response:', response.data);
        } catch (error) {
            // Обработка ошибок
            console.error('Error:', error.response ? error.response.data : error.message);
        }
    };
    // Функция для обработки изменения кода
    const handleCodeChange = (index, value) => {
        if (value.length > 1) return; // Ограничиваем ввод до одного символа
        const newCode = [...code];

        // Если значение пустое, то удаляем символ и переходим на предыдущий инпут
        if (value === '') {
            newCode[index] = '-';
            if (index > 0) {
                document.getElementById(`code-input-${index - 1}`).focus();
            }
        } else {
            newCode[index] = value.toUpperCase(); // Заменяем символ и переводим в верхний регистр
            if (index < 5) {
                document.getElementById(`code-input-${index + 1}`).focus();
            }
        }

        setCode(newCode);

        // Проверка на валидность кода
        if (newCode.every(char => char !== '-')) {
            setIsCodeValid(true);
        } else {
            setIsCodeValid(false);
        }
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
    };

    // Функция для отправки кода
    const handleSubmit = async (e) => {
        e.preventDefault(); // предотвращаем перезагрузку страницы
        const enteredCode = code.join('');
        console.log('Код подтверждения:', enteredCode);

        // Сравниваем введенный код с сохраненным confirm

        try {
            const response = await fetch(`${BACKEND_URL}/api/v1/auth/registration/confirm`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, confirmation_code: enteredCode }),
            });

            if (!response.ok) {
                setError('Неверный код подтвеждения')
            } else {
                const data = await response.json();
                console.log('Подтверждение:', data);
                window.location.replace("/")
            }


            // Здесь можно добавить логику для перехода на другую страницу или уведомления пользователя

        } catch (error) {
            console.error('Ошибка:', error);
            alert('Ошибка: ' + error.message); // Показать ошибку пользователю
        }
        // } else {
        //     alert('Неверный код подтверждения. Пожалуйста, попробуйте снова.');
        // }
    };

    // Таймер для обратного отсчета
    useEffect(() => {
        const interval = setInterval(() => {
            if (timer > 0) {
                setTimer(prevTimer => prevTimer - 1);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [timer]);

    return (
        <>
            <div className='w-full p-8 h-screen hidden lg:grid lg:grid-cols-2'>
                <div className='w-full h-full gap-4 items-center justify-center flex flex-col items-center'>
                    <img className='h-9 w-9' src='./ula.png' />
                    <span className='font-medium text-[40px]'>Подтверждение</span>
                    <span className='text-[16px] text-[#4B535B]'>Мы отправили код подтверждения на адрес</span>

                    <div className='py-2 px-4 w-[60%] flex justify-between items-center flex-row rounded-2xl border-[#AFB5BC] border-[1px]'>
                        <div className='flex flex-col'>
                            <input autoComplete={"off"}
                                value={email}
                                readOnly={!isEdit}
                                onChange={handleEmailChange}
                                className='border-none outline-none'
                            />
                        </div>

                        <span onClick={() => setIsEdit(!isEdit)} className={`rounded-full border-[1px] ${isEdit ? "bg-[#353A40] text-white" : ""} border-black py-2 px-5 hover:text-white hover:bg-[#353A40]`}>Изменить</span>
                    </div>

                    <span className='text-[#4B535B]'>Код подтверждения</span>
                    {error && <span className='text-red-500'>{error}</span>}
                    <div className='w-[60%] grid grid-cols-6'>
                        {code.map((char, index) => (
                            <div key={index} className='w-[90%] border-[#4B535B] border-[1px] rounded-2xl px-3 py-4 flex mx-auto items-center justify-center'>
                                <input autoComplete={"off"}
                                    id={`code-input-${index}`}
                                    className='w-full h-full text-[40px] text-center border-none outline-none'
                                    value={char === '-' ? '' : char}
                                    onChange={(e) => handleCodeChange(index, e.target.value)}
                                    onFocus={(e) => e.target.select()} // Выделяем текст при фокусе
                                    maxLength={1}
                                />

                            </div>
                        ))}
                    </div>


                    <div className='bg-[#EFF0F2] w-[60%] items-center rounded-2xl p-4 flex flex-row justify-between '>
                        <span className='text-[16px]'>Отправить код повторно через</span>
                        <span className='text-[20px]'>{`00:${String(timer).padStart(2, '0')}`}</span>
                    </div>


                    <div
                        className={`flex flex-row justify-between rounded-full w-[60%] py-4 px-8 ${isCodeValid ? 'bg-[#C3372E] hover:bg-[#E0473F]' : 'bg-gray-400 cursor-not-allowed'}`}
                        onClick={isCodeValid ? handleSubmit : null}
                    >
                        <span className='text-white text-[20px' disabled={!isCodeValid} onClick={handleSubmit}>Присоедениться</span>
                        <img className='w-7' src='./Arrow_right.png' />
                    </div>

                    <div className='flex flex-row items-center gap-8'>
                        <span className='text'>
                            У вас уже есть аккаунт?
                        </span>

                        <a href="/login" className='rounded-full border-[1px] border-black py-2 px-5 hover:text-white hover:bg-[#353A40]'>
                            Войти
                        </a>
                    </div>



                </div>

                <img style={{ aspectRatio: 1 }} className='w-full my-auto' src='/AuthBg.png' />
            </div>












            <div className='w-full p-8 min-h-screen hidden sm:grid lg:hidden lg:grid-cols-1'>
                <img className='w-full my-auto' src='/AuthBgLaptop.png' />

                <div className='w-full h-full gap-4 items-center justify-center flex flex-col items-center'>
                    <img className='h-9 w-9' src='./ula.png' />
                    <span className='font-medium text-[40px]'>Подтверждение</span>
                    <span className='text-[16px] text-[#4B535B]'>Мы отправили код подтверждения на адрес</span>

                    <div className='py-2 px-4 w-[80%] flex justify-between items-center flex-row rounded-2xl border-[#AFB5BC] border-[1px]'>
                        <div className='flex flex-col'>
                            <input autoComplete={"off"}
                                value={email}
                                readOnly={!isEdit}
                                onChange={handleEmailChange}
                                className='border-none outline-none'
                            />
                        </div>

                        <span onClick={() => setIsEdit(!isEdit)} className={`rounded-full border-[1px] ${isEdit ? "bg-[#353A40] text-white" : ""} border-black py-2 px-5 hover:text-white hover:bg-[#353A40]`}>Изменить</span>
                    </div>

                    <span className='text-[#4B535B]'>Код подтверждения</span>
                    {error && <span className='text-red-500'>{error}</span>}
                    <div className='w-[80%] grid grid-cols-6'>
                        {code.map((char, index) => (
                            <div key={index} className='w-[90%] border-[#4B535B] border-[1px] rounded-2xl px-3 py-4 flex mx-auto items-center justify-center'>
                                <input autoComplete={"off"}
                                    id={`code-input-${index}`}
                                    className='w-full h-full text-[40px] text-center border-none outline-none'
                                    value={char === '-' ? '' : char}
                                    onChange={(e) => handleCodeChange(index, e.target.value)}
                                    onFocus={(e) => e.target.select()} // Выделяем текст при фокусе
                                    maxLength={1}
                                />

                            </div>
                        ))}
                    </div>


                    <div className='bg-[#EFF0F2] w-[80%] items-center rounded-2xl p-4 flex flex-row justify-between '>
                        <span className='text-[16px]'>Отправить код повторно через</span>
                        <span className='text-[20px]'>{`00:${String(timer).padStart(2, '0')}`}</span>
                    </div>


                    <div
                        className={`flex flex-row justify-between rounded-full w-[80%] py-4 px-8 ${isCodeValid ? 'bg-[#C3372E] hover:bg-[#E0473F]' : 'bg-gray-400 cursor-not-allowed'}`}
                        onClick={isCodeValid ? handleSubmit : null}
                    >
                        <span className='text-white text-[20px]' onClick={handleSubmit}>Присоедениться</span>
                        <img className='w-7' src='./Arrow_right.png' />
                    </div>

                    <div className='flex flex-row items-center gap-8'>
                        <span className='text'>
                            У вас уже есть аккаунт?
                        </span>

                        <a href="/login" className='rounded-full border-[1px] border-black py-2 px-5 hover:text-white hover:bg-[#353A40]'>
                            Войти
                        </a>
                    </div>



                </div>
            </div>









            <div className='w-full p-8 min-h-screen grid sm:hidden lg:grid-cols-1'>

                <div className='w-full h-full gap-4 items-center justify-center flex flex-col items-center'>
                    <img className='h-9 w-9' src='./ula.png' />
                    <span className='font-medium text-[40px]'>Подтверждение</span>
                    <span className='text-[16px] text-[#4B535B]'>Мы отправили код подтверждения на адрес</span>

                    <div className='py-2 px-4 w-[100%] flex justify-between items-center flex-row rounded-2xl border-[#AFB5BC] border-[1px]'>
                        <div className='flex flex-col'>
                            <input autoComplete={"off"}
                                value={email}
                                readOnly={!isEdit}
                                onChange={handleEmailChange}
                                className='border-none outline-none'
                            />
                        </div>

                        <span onClick={() => setIsEdit(!isEdit)} className={`rounded-full border-[1px] ${isEdit ? "bg-[#353A40] text-white" : ""} border-black py-2 px-5 hover:text-white hover:bg-[#353A40]`}>Изменить</span>
                    </div>

                    <span className='text-[#4B535B]'>Код подтверждения</span>
                    {error && <span className='text-red-500'>{error}</span>}
                    <div className='w-[100%] grid grid-cols-6'>
                        {code.map((char, index) => (
                            <div key={index} className='w-[90%] border-[#4B535B] border-[1px] rounded-2xl px-1 py-2 flex mx-auto items-center justify-center'>
                                <input autoComplete={"off"}
                                    id={`code-input-${index}`}
                                    className='w-[30px] h-full text-[30px] text-center border-none outline-none'
                                    value={char === '-' ? '' : char}
                                    onChange={(e) => handleCodeChange(index, e.target.value)}
                                    onFocus={(e) => e.target.select()} // Выделяем текст при фокусе
                                    maxLength={1}
                                />

                            </div>
                        ))}
                    </div>


                    <div className='bg-[#EFF0F2] w-[100%] items-center rounded-2xl p-4 flex flex-row justify-between '>
                        <span className='text-[16px]'>Отправить код повторно через</span>
                        <span className='text-[20px]'>{`00:${String(timer).padStart(2, '0')}`}</span>
                    </div>


                    <div
                        className={`flex flex-row justify-between rounded-full w-[100%] py-4 px-8 ${isCodeValid ? 'bg-[#C3372E] hover:bg-[#E0473F]' : 'bg-gray-400 cursor-not-allowed'}`}
                        onClick={isCodeValid ? handleSubmit : null}
                    >
                        <span className='text-white text-[20px]' onClick={handleSubmit}>Присоедениться</span>
                        <img className='w-7' src='./Arrow_right.png' />
                    </div>

                    <div className='flex flex-row items-center gap-8'>
                        <span className='text'>
                            У вас уже есть аккаунт?
                        </span>

                        <a href="/login" className='rounded-full border-[1px] border-black py-2 px-5 hover:text-white hover:bg-[#353A40]'>
                            Войти
                        </a>
                    </div>



                </div>

                <img className='w-full mt-8 my-auto' src='/AuthBgMobile.png' />

            </div>
        </>

    );
};

export default Confirm;
